import React from "react";
import About from "../components/home/About";
import Review from "../components/home/Review";
import MentoringBeyond from "../components/home/MentoringBeyond";
import Details from "../components/home/Details";
import Courses from "../components/home/Courses";
import Testimonials from "../components/home/Testimonials";
import Mentors from "../components/home/Mentor";
import ContactSection from "../components/home/ContactSection";
import Hero from "../components/home/Hero";

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Testimonials/>
      <Review />
      <Details />
      <Courses />
      <MentoringBeyond />
      <Mentors />

      <ContactSection />
    </div>
  );
};

export default Home;
